const NEWBORN = 'NEO_NATAL';
const ADULT = 'ADULTO';
const PEDIATRIC = 'PEDIATRICO';

const NEWBORN_PESO = 1;
const ADULT_PESO = 70;
const PEDIATRIC_PESO = 25;

const NEWBORN_LABEL = 'Neonato';
const ADULT_LABEL = 'Adulto';
const PEDIATRIC_LABEL = 'Pediátrico';

const PATIENT_NEWBORN_ATERMO = 'TERMO';
const PATIENT_NEWBORN_PRETERMO = 'PRETERMO';

const PATIENT_NEWBORN_ATERMO_LABEL = 'A termo';
const PATIENT_NEWBORN_PRETERMO_LABEL = 'Pré-termo';

const PATIENT_TYPES = {
  [NEWBORN]: NEWBORN_LABEL,
  [ADULT]: ADULT_LABEL,
  [PEDIATRIC]: PEDIATRIC_LABEL,
};

export const PATIENT_TYPES_LIST = [
  { id: NEWBORN, name: NEWBORN_LABEL, icon: 'fa-baby', iconColor: '#32CD32', bgColor: 'rgb(253 255 229) !important;' },
  { id: PEDIATRIC, name: PEDIATRIC_LABEL, icon: 'fa-child', iconColor: '#FF4500', bgColor: 'rgb(225 255 230) !important;' },
  { id: ADULT, name: ADULT_LABEL, icon: 'fa-user-tie', iconColor: '#A020F0', bgColor: 'rgb(234 248 249) !important;' },
];

export function getPatientType(id) {
  if (!id) {
    return null;
  }
  return PATIENT_TYPES_LIST.filter(t => t.id == id)[0];
}

const PATIENT_NEWBORN_TYPES = {
  [PATIENT_NEWBORN_ATERMO]: PATIENT_NEWBORN_ATERMO_LABEL,
  [PATIENT_NEWBORN_PRETERMO]: PATIENT_NEWBORN_PRETERMO_LABEL,
};

const GENDER_MALE = 'MASCULINO';
const GENDER_FEMALE = 'FEMININO';
const GENDER_MALE_LABEL = 'Masculino';
const GENDER_FEMALE_LABEL = 'Feminino';

const GENDERS = {
  [GENDER_MALE]: GENDER_MALE_LABEL,
  [GENDER_FEMALE]: GENDER_FEMALE_LABEL,
};

export {
  NEWBORN,
  ADULT,
  PEDIATRIC,
  PATIENT_TYPES,
  PATIENT_NEWBORN_TYPES,
  GENDERS,
  NEWBORN_PESO,
  ADULT_PESO,
  PEDIATRIC_PESO,
};
